module.exports = __webpack_public_path__ + "static/media/biocertica-id-logo-with-text-default-vertical.bddaf683.svg";